module.exports = __webpack_public_path__ + "static/media/OWU BNPP_CASHCPI_3_3.3.2020 _Cardif_Rzeczówka Light.51598ee0.pdf";